const jwt = require('jsonwebtoken')
import { jwtConfig } from '../_configs'

const users = [
    {
        username: 'Ben',
        pw: 'ben'
    },
    {
        username: 'Cassie',
        pw: 'cassie'
    },
    {
        username: 'Amber',
        pw: 'amber'
    },
    {
        username: 'Nana',
        pw: 'nana'
    },
    {
        username: 'Papa',
        pw: 'papa'
    },
    {
        username: 'Santa',
        pw: 'santa'
    },
    {
        username: 'Joe',
        pw: 'joe'
    }
]

export const userService = {
    login,
    logout
}

// login() handles login requests to the server
function login(username, password) {
    let validated = false
    let validatedUser = {}

    users.forEach(user => {
        if(user.username == username && user.pw == password) {
            validated = true
            validatedUser.name = user.username
        }
    })

    if(validated) {
        // create the token and complete successful login
        let token = jwt.sign(validatedUser, jwtConfig.default.secret, { expiresIn: 43200 })
        // store token
        localStorage.setItem('ben-token', token)
        // return the user
        return validatedUser
    } else {
        logout()
        alert('Username or password are incorrect')
        window.location.reload(true)
        return 'No'
    }
}

// logout() handles logging a user out
function logout() {
    // get user info from token
    let theToken = localStorage.getItem('ben-token')

    // if there is a jwt token, decode it and log the user out
    if(theToken) {
        // remove token from local storage
        localStorage.removeItem('ben-token')
        // send to login page
        // window.location.assign('http://www.ben-miller.net.s3-website-us-west-1.amazonaws.com/')
        window.location.assign('http://www.ben-miller.net/')
    }
}


// handleResponse() checks if the response status is OK
// if it is OK it returns the data of the response
// if it is not OK it ensures that the user is logged out, reloads the page,
// and sends an alert that either the Username or Password was incorrect
// function handleResponse(response) {
//     if(!response.data.ok) {
//         logout()
//         alert('Username or password are incorrect')
//         window.location.reload(true)

//         const error = (response.data && response.data.message) || response.statusText
//         return Promise.reject(error)
//     }

//     return response.data
// }